import { assertUnreachable } from '@luminovo/commons';
import {
    FullPart,
    isCustomComponentFull,
    isCustomFullPart,
    isGenericFullPart,
    isOtsComponentFull,
    isOtsFullPart,
} from '@luminovo/http-client';
import { DatasheetIconButton } from '@luminovo/sourcing-core';
import { TableCell } from './TableCell';

export const RenderDatasheet = ({ part, onClick }: { part: FullPart; onClick?: () => void }): JSX.Element => {
    if (isOtsFullPart(part)) {
        const url = part.datasheet_url;
        if (!url) {
            return <TableCell onClick={onClick}>-</TableCell>;
        }

        return (
            <TableCell style={{ padding: 0 }} onClick={onClick}>
                <DatasheetIconButton url={url} />
            </TableCell>
        );
    }
    if (isOtsComponentFull(part) || isCustomComponentFull(part)) {
        return (
            <TableCell onClick={onClick} isComponentRemoved={part.state === 'Removed'}>
                -
            </TableCell>
        );
    }
    if (isGenericFullPart(part) || isCustomFullPart(part)) {
        return <TableCell onClick={onClick}>-</TableCell>;
    }

    assertUnreachable(part);
};
